import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FavoriteViewsService } from './services/favorite-views.service';
import { FavoriteViewsEffects } from './state/effects/favorite-views.effects';
import * as fromFavoriteViews from './state/reducers';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromFavoriteViews.favoriteViewsFeatureKey, fromFavoriteViews.reducers),
    EffectsModule.forFeature([FavoriteViewsEffects])
  ],
  providers: [FavoriteViewsService]
})
export class FavoriteViewsModule {}
